import React from 'react'
import { Box, Link, Collapse, Typography, styled } from '@mui/material'
import { CheckedIcon } from '../../eid-icons'
import PropTypes from 'prop-types'

const CollapsibleListContainer = styled(Box)(({ theme }) => ({
    paddingRight: '1.9rem',
    marginBottom: '1.5rem',
}))

const ListItemLabel = styled(Typography)(({ theme }) => ({
    fontSize: '1.4rem',
    marginLeft: '1rem',
    color: '#000000',
}))

const ShowAllButton = styled(Typography)(({ theme }) => ({
    fontSize: '1.4rem',
    textDecoration: 'underline',
}))

const GradientBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    WebkitMaskImage:
        !open &&
        '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(255,255,255,0)))',
}))

const CollapsibleList = ({ list, visibleItems, getLabel, showAllText }) => {
    const [open, setOpen] = React.useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    if (list.length < visibleItems) {
        return (
            <CollapsibleListContainer>
                {list.map((item, index) => (
                    <Box sx={{ marginBottom: '1rem' }} key={index}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CheckedIcon />
                            <ListItemLabel>{getLabel(item)}</ListItemLabel>
                        </Box>
                    </Box>
                ))}
            </CollapsibleListContainer>
        )
    }

    return (
        <CollapsibleListContainer>
            {list.slice(0, visibleItems - 1).map((item, index) => (
                <Box sx={{ marginBottom: '1rem' }} key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckedIcon />
                        <ListItemLabel>{getLabel(item)}</ListItemLabel>
                    </Box>
                </Box>
            ))}
            <GradientBox open={open}>
                <Box sx={{ marginBottom: '1rem' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckedIcon />
                        <ListItemLabel>{getLabel(list[2])}</ListItemLabel>
                    </Box>
                </Box>
            </GradientBox>

            <Collapse in={open} timeout="auto" unmountOnExit>
                {list.slice(3).map((item, index) => (
                    <Box sx={{ marginBottom: '1rem' }} key={index}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CheckedIcon />
                            <ListItemLabel>{getLabel(item)}</ListItemLabel>
                        </Box>
                    </Box>
                ))}
            </Collapse>

            {!open && (
                <Box sx={{ marginTop: '1.5rem' }}>
                    <Link component="button" onClick={handleClick}>
                        <ShowAllButton>{showAllText}</ShowAllButton>
                    </Link>
                </Box>
            )}
        </CollapsibleListContainer>
    )
}

CollapsibleList.propTypes = {
    /**
     * List of items to render out in the list
     */
    list: PropTypes.array,

    /**
     * Number of items to show when collapsed
     */
    visibleItems: PropTypes.number,

    /**
     * Text to show as a prompt for "Show All Items"
     */
    showAllText: PropTypes.string,
}

CollapsibleList.defaultProps = {
    list: [],
    visibleItems: 3,
    showAllText: 'Show All',
}

export default CollapsibleList
